
import CONFIG from "../temp/config";
import {isValid, mygaSession} from "./myga-session";
import {
  APP_SECTION, CALL_SCHEDULE_CUSTOMER,
  CHANNEL_TYPE,
  createObjectForKeys, getAgeFromDOB,
  LEAD_TYPE, PARTY,
  PRODUCT_ID
} from "./constants";
import {apigHelperFactory} from "./apig-helper";
import {NassauLog} from "./myga-utils";
import {MM_PRODUCT, MM_PRODUCT_DTO} from "./myga-model";
import {productForDTO} from "./product-manager";

export let getTimeTextForHour24 = (hourAs24) => {
  return `${((hourAs24-1)%12)+1}:00${hourAs24>=12?'PM':'AM'}`
};

export let getToken = async () => {
  
  // 2017.07.27.ADivelbiss - Create a new APIGhelper
  const apigHelper = apigHelperFactory();
  
  let result = await apigHelper.postFormData({'token':'get'});
    
    NassauLog('dtcToken: ' + JSON.stringify(result));
    return result.token;
};

// 2021.09.03.ADivelbiss - moved age calculation to the mygaSession since age
// is now needed for some suitability rules.

export let loadTimeSlots = async (requestDate) => {
  let url = CONFIG.schedueAPI.schedulerUrl;
  
  // Create the POST body for guest access
  let body = {
    'requestType' : 'timeslots',
  };
  
  // Setup the requestDate
  if (isValid(requestDate) && (requestDate.length>0)) {
    body.requestDate = requestDate;
  }
  
  // Form the post headers
  let headers = {
    'Content-Type':'application/json'
  };
  
  let response = await fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return await response.json();
};

export let scheduleCall = async (dtcToken, daySelection, timeSelection, tz) => {
  
  // Get the current application
  let appData = mygaSession.getCurrentApp();
  if (!isValid(appData)) {
    throw new Error(`scheduleCall error! current appData not found`);
  }
  
  NassauLog(`scheduleCall daySelection: ${daySelection}`);
  NassauLog(`scheduleCall timeSelection: ${timeSelection}`);
  
  // get the customer information.
  let customer = createObjectForKeys(CALL_SCHEDULE_CUSTOMER,"");
  // 2022.05.25.ADivelbiss - switch to using the owner
  const owner = mygaSession.getCurrentAppOwner();
  // 2022.05.25.ADivelbiss - updated to support MYGA
  // must be at least one product to get this far
  const product = productForDTO(mygaSession.getCurrentAppProductDTOs()[0]);
  customer[CALL_SCHEDULE_CUSTOMER.state] = owner[PARTY.addressState];
  customer[CALL_SCHEDULE_CUSTOMER.dob] = owner[PARTY.dob].split('-').join('/');
  customer[CALL_SCHEDULE_CUSTOMER.age] = getAgeFromDOB(owner,PARTY.dob);
  customer[CALL_SCHEDULE_CUSTOMER.token] = dtcToken;
  customer[CALL_SCHEDULE_CUSTOMER.requestType] = "contact";
  customer[CALL_SCHEDULE_CUSTOMER.channelSource] = "Direct";
  customer[CALL_SCHEDULE_CUSTOMER.productName] = product[MM_PRODUCT.productName];
  // call scheduler can only take one deposit type so choose the first one.
  // 2022.05.25.ADivelbiss - updated to support MYGA
  customer[CALL_SCHEDULE_CUSTOMER.term] = product[MM_PRODUCT_DTO.surrenderPeriod];
  customer[CALL_SCHEDULE_CUSTOMER.rate] = product[MM_PRODUCT_DTO.rate];
  customer[CALL_SCHEDULE_CUSTOMER.amount] = product[MM_PRODUCT_DTO.premium];
  customer[CALL_SCHEDULE_CUSTOMER.firstName] = owner[PARTY.firstName];
  customer[CALL_SCHEDULE_CUSTOMER.lastName] = owner[PARTY.lastName];
  customer[CALL_SCHEDULE_CUSTOMER.email] = owner[PARTY.email];
  customer[CALL_SCHEDULE_CUSTOMER.phone] = owner[PARTY.daytimePhone];
  customer[CALL_SCHEDULE_CUSTOMER.insuredFirstName] =owner[PARTY.firstName];
  customer[CALL_SCHEDULE_CUSTOMER.insuredLastName] = owner[PARTY.lastName];
  customer[CALL_SCHEDULE_CUSTOMER.insuredPhone] = owner[PARTY.daytimePhone];
  customer[CALL_SCHEDULE_CUSTOMER.flowType] = "Quote to Apply";
  
  //appointment
  let time = timeSelection;
  let parts = daySelection.split('-');
  customer[CALL_SCHEDULE_CUSTOMER.appointment] = parts[1]+'/' + parts[2] + '/' + parts[0] + ' ' + getTimeTextForHour24(timeSelection);
  
  // NB. The following works only because we are not near a day boundary.
  let dt = `${daySelection}T${String((timeSelection+(tz==='EDT'?4:5))).padStart(2,'0')}:00:00`;

  // Get the url
  let url = CONFIG.schedueAPI.schedulerUrl;

  let body = {};
  body.token = dtcToken;
  body.requestType = "schedule";
  body.requestDate = daySelection;
  body.hour = timeSelection;
  body.appointmentTime = dt;
  body.customer = customer;
  body.dtcType = 'Q2A';
  body.leadType = LEAD_TYPE.mygaLead;  //product specific
  body.product = PRODUCT_ID.simpleAnnuity;
  body.channelSource = CHANNEL_TYPE.direct;
  
  // check for valid payment info
  if (mygaSession.isCurrentAppSectionDataAvailable(APP_SECTION.payments)) {
      body.action = "postToSF";
      body.applicationStatus = 'Full Application';
  } else {
      body.action = "postToBoth";
      body.applicationStatus = 'Partial Application';
  }
  
  NassauLog(`scheduleCall body: ${JSON.stringify(body,null,2)}`);
  
  
  // Form the post headers
  let headers = {
    'Content-Type':'application/json'
  };

  let response = await fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};


